import React from "react";
import { OvalNeumorphicBtn } from "../buttons";
import { XIcon } from "../icons";
import "./errorMessageModal.scss"; // Import styles

const ErrorMessageModal = ({ message, onClose }) => {
  return (
    <div className="error-modal-overlay">
      <div id = "error-modal" className="error-modal-content">
        <div className="error-modal-header">
          <h2>Error</h2>
        </div>
        <div className="error-modal-body">
          <p className="error-modal-color">{message}</p>
        </div>
        <div className="error-modal-footer">
          <OvalNeumorphicBtn
            onClick={onClose}
            className="ok-button-error-modal"
            icon={
              <XIcon width="15" height="15" fillColor="var(--color-hotRed)" />
            }
            text="K"
            color="var(--color-hotRed)"
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorMessageModal;
